<span class="product-price"
      [ngClass]="classList">
  {{!isShowFreeLabel ? (priceValue|customCurrency:quantity) : 'shared.labels.free'|translate }}
</span>
